export default "__VITE_ASSET__81618afc__"